import request from "@/utils/request";

export function getCarAttributeFeeConfig({ params , orderSource }){
  return request({
    url:`/basic/${orderSource}/api/carInfo/carAttributeFeeConfig`,
    method:"GET",
    params
  })
}